import React from 'react'
import PropTypes from 'prop-types'
import {
  BUTTON_TYPE,
  CONTAINER_STYLE,
  DIVIDER_SIZE,
  HEADING_TYPE,
  TEXT_SIZES,
  TEXT_ALIGN,
  BOOK_LIST_TYPES,
} from '@helpers/constants'
import Container from '@components/Container'
import Heading from '@components/Heading'
import Text from '@components/Text'
import Divider from '@components/Divider'
import BookList from '@components/BookList'
import Button from '@components/Button'

const NewBooks = (props) => {
  const { heading, text, books } = props

  return (
    <Container size={CONTAINER_STYLE.DESKTOP} paddingTop={false}>
      <div className='flex flex-col items-center'>
        {heading && (
          <Heading headingLevel={HEADING_TYPE.H1} size={TEXT_SIZES.XXLARGE}>
            {heading}
          </Heading>
        )}
        {text && (
          <div className='max-w-[600px]'>
            <Text align={TEXT_ALIGN.CENTER}>{text}</Text>
          </div>
        )}

        <Divider size={DIVIDER_SIZE.SMALL} />

        <Button
          type={BUTTON_TYPE.SECONDARY}
          to={'bibliotek/bocker'}
          icon={'ArrowRight'}
          iconClasses={'w-4 h-4'}
          iconRight
        >
          Visa alla böcker
        </Button>

        <Divider size={DIVIDER_SIZE.BASE} />

        <BookList type={BOOK_LIST_TYPES.LIBRARY} items={books.slice(0, 4)} />
      </div>
    </Container>
  )
}

NewBooks.propTypes = {
  heading: PropTypes.string,
  text: PropTypes.string,
  books: PropTypes.array,
}

export default NewBooks
